import { config } from './app.config';
var ɵ0 = { endPoint: config.autoSuggestApi, page: 0, searchPageUrl: 'search-result-page' }, ɵ1 = window;
var AppModule = /** @class */ (function () {
    function AppModule() {
    }
    return AppModule;
}());
export { AppModule };
export { ɵ0, ɵ1 };
